import { RootState } from '@reducers';

export const selectCarClaim = (state: RootState) => state.userDashboardRouteReducer.claimDetails.carClaimDetails;
